var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 305.63 434.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1c1c1c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1112.71,533.38l-26-49.88V386.93a63.69,63.69,0,0,0-63.62-63.62H897.22a63.69,63.69,0,0,0-63.62,63.62V482.5l-26.51,50.88v53.71l26.51,38.64v26.65a105.32,105.32,0,0,0,105.2,105.2h42.72a105.32,105.32,0,0,0,105.2-105.2V625l26-37.88Zm-111.4-62.61-24.59,58.35H944.23l-23.07-58.33V334.61H999.1ZM897.22,334.61h12.64V473l26.68,67.47h47.68L1012.65,473l-2.25-138.36h12.7a52.38,52.38,0,0,1,52.32,52.32v188a125.91,125.91,0,0,1-48.31,55,129.24,129.24,0,0,1-133.89,0,125.79,125.79,0,0,1-48.31-55v-188A52.38,52.38,0,0,1,897.22,334.61Zm-78.83,249V536.15L833.6,507v98.8Zm163.13,162.7H938.8a94,94,0,0,1-93.89-93.9V598.2a135.27,135.27,0,0,0,42.4,41.39,140.59,140.59,0,0,0,145.71,0,135.38,135.38,0,0,0,42.4-41.39v54.18A94,94,0,0,1,981.52,746.28Zm119.89-162.7L1086.72,605V508l14.69,28.19Z",
    transform: "translate(-807.09 -323.31)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M984.84,445V349.67H934.12V445Zm-39.42-57.31h28.11v16.9H945.42Zm0,46v-17.8h28.11v17.8ZM973.53,361v15.38H945.42V361Z",
    transform: "translate(-807.09 -323.31)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.0310097c44931f27d300cdff30ae59aa.svg";
export { ForwardRef as ReactComponent };